import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { browserHistory } from 'react-router';

import { queryDeleteIncuOregistapp, queryIncuOregistappWorkflow } from '@api/incubator/oregistapp';

import FormBase from '../contract/address/PageAddress';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.getIncuOregistappWorkflow();
  }

  getIncuOregistappWorkflow = params => {
    const { instance } = this.state;
    queryIncuOregistappWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  handleCompayChange = uuid => {
    this.getIncuOregistappWorkflow({
      company: uuid,
    });
  };

  deleteRecoup = () => {
    queryDeleteIncuOregistapp({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={this.props.data}
          handleDelete={this.deleteRecoup}
          isSubmitting={isSubmitting}
          onCompanyChange={this.handleCompayChange}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/oregistapp/PageEdit.js